import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CurrentUserEffects } from './store/current-user/current-user.effects';
import {
  CurrentUserConfigToken,
  CurrentUserNamespace,
  CurrentUserReducer,
} from './store/current-user/current-user.store';
import { DeletionRequestsEffects } from './store/deletion-requests/deletion-requests.effects';
import {
  DeletionRequestNamespace,
  DeletionRequestReducer,
} from './store/deletion-requests/deletion-requests.store';
import { GuestNamespace, GuestReducer } from './store/guest/guest.store';
import { ReportConfigurationEffects } from './store/report-configuration/report-configuration.effects';
import {
  ReportConfigurationNamespace,
  ReportConfigurationReducer,
} from './store/report-configuration/report-configuration.store';
import { SecureChangeEffects } from './store/secure-change/secure-change.effects';
import {
  SecureChangeNamespace,
  SecureChangeReducer,
} from './store/secure-change/secure-change.store';
import { UserEffects } from './store/user/user.effects';
import { UserNamespace, UserReducer } from './store/user/user.store';

@NgModule({
  imports: [
    StoreModule.forFeature(ReportConfigurationNamespace, ReportConfigurationReducer),
    StoreModule.forFeature(DeletionRequestNamespace, DeletionRequestReducer),
    StoreModule.forFeature(CurrentUserNamespace, CurrentUserReducer, CurrentUserConfigToken),
    StoreModule.forFeature(UserNamespace, UserReducer),
    StoreModule.forFeature(GuestNamespace, GuestReducer),
    StoreModule.forFeature(SecureChangeNamespace, SecureChangeReducer),
    EffectsModule.forFeature([
      CurrentUserEffects,
      DeletionRequestsEffects,
      ReportConfigurationEffects,
      UserEffects,
      SecureChangeEffects,
    ]),
  ],
})
export class AccountDataStoreModule {
  constructor(private _: CurrentUserEffects) {}
}
